 import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import moment from 'moment'

// API
import * as API  from '../../../utils/api'

// Packages
import { Helmet } from 'react-helmet'

// Actions
import {
  getProfileAccountDetails
} from '../../../actions/accountDetails'

// Components
import Header from '../../../components/Global/Header'
import Footer from '../../../components/Global/Footer'
import AccountSettingsNav from '../../../components/UserPortal/AccountSettings/AccountSettingsNav'
import FormContainer from '../../../components/Global/FormContainer'
import AppCanvasLoader from '../../../components/Global/AppCanvasLoader'
import FlashMessage from '../../../components/Global/FlashMessage';

// Utils
import {
  getAllUrlParams,
} from '../../../utils/helpers';

class PaymentInfo extends Component {
  state = {
    payments: [],
    paymentInfo: null,
    redirectToPaymentInfoSubscribe: false,
    flashMessage: {
      type: '',
      message: '',
    },
    displayFlashMessage: false,
    isLoading: true,
  }

  componentDidMount() {
    const params = getAllUrlParams(window.location.href)

    if (params.message) {
      this.setState({
        flashMessage: {
          type: '',
          message: decodeURI(params.message)
        },
        displayFlashMessage: true
      })
    }

    if (window.location.href.includes('confirmed')) {
      this.showPaymentAcceptedMessage()
    }

    this.initializePaymentInfo(this.props)
  }

  componentWillReceiveProps(nextProps) {
    // Check to see if kid picker caused activeProfile to change
    if (this.props.activeProfile.username !== nextProps.activeProfile.username) {
      this.initializePaymentInfo(nextProps)
    }
  }

  initializePaymentInfo(props) {
    const { user, activeProfile } = props

    if (activeProfile.subscribed) {
      API.getProfileLevelAccountInfo(user, activeProfile.username)
      .then(response => {
        const { payment_info } = response

        if (payment_info) {
          const { payments } = payment_info
          this.setState({
            paymentInfo: payment_info,
            payments,
            isLoading: false
          })
        } else {
          console.log('Error fetching billing info: ', response)
          this.setState({
            payments: [],
            isLoading: false
          })
        }
      })
    } else {
      this.setState({redirectToPaymentInfoSubscribe: true})
    }
  }

  showPaymentAcceptedMessage() {
    this.setState({
      flashMessage: {
        type: '',
        message: 'Your payment was successful. You are now signed up for Locker Linked Premium'
      },
      displayFlashMessage: true
    })
  }

  renderPlanInfo() {
    const { paymentInfo } = this.state

    if (paymentInfo) {
      const {
        subscribed,
        payments,
        canceled,
        subscription_ends_on,
      } = paymentInfo

      let initialPaymentIndex = payments.length - 1

      // If subscribed, but account is canceled
      if (subscribed && canceled) {
        return (
          <p>
            Your account has been canceled. Your current subscription will end on {moment(subscription_ends_on).format("M/DD/YYYY")}
          </p>
        )
      }

      if (subscribed) {
        return (
          <p>
            You are on a paid plan. Your plan started on {payments[initialPaymentIndex].date}
          </p>
        )
      }

      return (
        <p>
          You are not a paid plan.
        </p>
      )
    }
  }

  renderPayments() {
    const { payments } = this.state

    return payments.length > 0
    ? (
      <ul className="payment-info-payments">
        {payments.map((payment, index) => {
          return payment.dollar_amount !== "0.00"
          ? (
            <li className="account-payment" key={`payment-${index}`}>
              <div className="account-payment-description">
                <h3 className="account-payment-description-title">
                  {payment.paid ? `Completed Payment` : 'Upcoming Payment'}
                </h3>
                <p className="account-payment-description-date">
                  {payment.paid ? 'Paid on' : 'Scheduled for '} {payment.date}
                </p>
              </div>
              <p className="account-payment-dollar-amount">
               {payment.paid ? '' : 'Not yet paid |'} ${payment.dollar_amount}
              </p>
            </li>
          ) : null
        })}
      </ul>
    )
    : null
  }

  renderFlashMessage() {
    const {
      displayFlashMessage,
      flashMessage
    } = this.state;

    return displayFlashMessage
    ? (
      <FlashMessage optionalClasses={flashMessage.type === 'error' ? 'error' : ''}>
        {flashMessage.message}
      </FlashMessage>
    ) : null
  }

  render() {
    const {
      path,
      appName,
    } = this.props

    const {
      isLoading,
      redirectToPaymentInfoSubscribe,
      paymentInfo,
    } = this.state


    return redirectToPaymentInfoSubscribe
    ? (<Redirect to={{ pathname: '/settings/payment-info/subscribe' }}/>)
    : (
      <div className="user-portal account-settings payment-info">
        <Helmet>
          <title>{appName} | Settings: Payment Info</title>
        </Helmet>
        <Header path={ path } />
        <AccountSettingsNav currentTab="payment-info"  />
        <FormContainer>
          <header>
            <h1>Payment Info</h1>
            {this.renderFlashMessage()}
            {isLoading ? null : this.renderPlanInfo()}
          </header>
          {isLoading ? <AppCanvasLoader/> : this.renderPayments()}
          {paymentInfo && paymentInfo.payments.length > 0 && <hr/>}
          <Link
            to="/settings/payment-info/update"
            className="cta full-width cta-gradient"
          >
            Update My Card Info
          </Link>
          {paymentInfo && !paymentInfo.canceled &&
            <Link
              to="/settings/payment-info/cancel-subscription"
              className="cta full-width invert"
            >
              Cancel My Subscription
            </Link>
          }
        </FormContainer>
        <Footer appName={ appName } path={ path } />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    accountDetails: state.accountDetails,
    activeProfile: state.activeProfile
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getProfileAccountDetails: (user, athleteUsername) => {
      dispatch(getProfileAccountDetails(user, athleteUsername))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentInfo)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Settings/PaymentInfo.js